import { render, staticRenderFns } from "./natResourceAddedPermission.vue?vue&type=template&id=2ac92e3c&"
import script from "./natResourceAddedPermission.vue?vue&type=script&lang=js&"
export * from "./natResourceAddedPermission.vue?vue&type=script&lang=js&"
import style0 from "./natResourceAddedPermission.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports